import {create} from 'zustand';
import {RatingValuesStore} from './types';

export const useRatingValuesStore = create<RatingValuesStore>(set => ({
	ratingValues: {},

	setRatingValue: (motivatorId, value) =>
		set(state => ({
			ratingValues: {
				...state.ratingValues,
				[motivatorId]: value,
			},
		})),

	resetRatingValue: motivatorId =>
		set(state => ({
			ratingValues: {
				...state.ratingValues,
				[motivatorId]: null,
			},
		})),
}));
